import { render, staticRenderFns } from "./FormF.vue?vue&type=template&id=bc1e9e76&scoped=true&"
import script from "./FormF.vue?vue&type=script&lang=js&"
export * from "./FormF.vue?vue&type=script&lang=js&"
import style0 from "./FormF.vue?vue&type=style&index=0&id=bc1e9e76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e9e76",
  null
  
)

export default component.exports